import { render, staticRenderFns } from "./AddGoods.vue?vue&type=template&id=04088820&scoped=true"
import script from "./AddGoods.vue?vue&type=script&lang=js"
export * from "./AddGoods.vue?vue&type=script&lang=js"
import style0 from "./AddGoods.vue?vue&type=style&index=0&id=04088820&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04088820",
  null
  
)

export default component.exports